export const ADS_NOTICE_VERSION = "openai-leads-regional-2026-10-26";
// US ordinary measurement is unchanged; conservatively ask everywhere else.
export function requiresAdvertisingConsent(region: string | null): boolean {
  return region !== "US";
}
export type AdsConsentRecord = {
  id: string;
  visitorId: string;
  advertising: "accepted" | "denied";
  region: string | null;
  recordedAt: string;
  noticeVersion: string;
};
export type AdsChoice = {
  region: string | null;
  advertising: "unanswered" | "accepted" | "denied";
  optedOut: boolean;
  noticeVersion: string;
  checkedAt: string;
  consentRecord?: AdsConsentRecord;
  consentHistory?: AdsConsentRecord[];
};

export function allowsOpenAIAds(choice: AdsChoice | null | undefined): boolean {
  if (!choice || choice.optedOut || choice.advertising === "denied" || choice.noticeVersion !== ADS_NOTICE_VERSION) return false;
  if (!requiresAdvertisingConsent(choice.region) && choice.advertising === "unanswered") return true;
  const record = choice.consentRecord;
  return choice.advertising === "accepted" && record?.advertising === "accepted" &&
    record.noticeVersion === ADS_NOTICE_VERSION && Boolean(record.id && record.visitorId && record.recordedAt);
}

export function allowsOpenAILead(original: AdsChoice | undefined, current: AdsChoice | undefined): boolean {
  return allowsOpenAIAds(original) && allowsOpenAIAds(current);
}